import { render, staticRenderFns } from "./base.vue?vue&type=template&id=58f668de&scoped=true&"
import script from "./base.vue?vue&type=script&lang=ts&"
export * from "./base.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f668de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58f668de')) {
      api.createRecord('58f668de', component.options)
    } else {
      api.reload('58f668de', component.options)
    }
    module.hot.accept("./base.vue?vue&type=template&id=58f668de&scoped=true&", function () {
      api.rerender('58f668de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/component/bulma/form/field/base.vue"
export default component.exports